<script setup lang="ts">
  import { DocumentSendControlList } from '@/features/DocumentSendControl';
</script>

<template>
  <div data-testid="document-management-send-control-page">
    <DocumentSendControlList />
  </div>
</template>
